exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".templates-managerment .templates .template{padding:1em;border:1px solid #ccc;border-radius:5px;margin:10px;display:inline-block;text-align:center;min-width:100px}.templates-managerment .templates .template .icon img{width:40px;height:40px;margin:5px}.templates-managerment .templates .template .name{font-weight:700;line-height:1.2em}.templates-managerment .templates .template .filename{line-height:1em;opacity:.8;font-size:.8em}.templates-managerment .templates .template .action-buttons{margin:10px 5px 0;padding:0}.templates-managerment .templates .template .action-buttons .file-uploads{overflow:inherit!important}.templates-managerment .templates .template .action-buttons i{opacity:.4;margin:0 5px}.templates-managerment .templates .template .action-buttons i:hover{opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3bc5b48","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/src/pages/Admin/TemplatesManagement.vue
// module id = 460
// module chunks = 0